import React, { useState } from 'react';
import "./About.css"
import Aboutme from './AboutCatagory/Aboutme';
import Awardme from './AboutCatagory/Awardme';
import Servicesme from './AboutCatagory/Servicesme';
import Skillsme from './AboutCatagory/Skillsme';
import Socialmediame from './AboutCatagory/Socialmediame';
import emailjs from 'emailjs-com';
import { FaFacebook,FaLinkedin,FaGithub,FaMapMarkerAlt} from 'react-icons/fa';
import Services from '../Services/Services';
const About = () => {
    const [state, setState] = useState(2)

    return (
        <div className="about" style={{ backgroundImage: "url(Images/bg.png)" }}>
            {/* <div className="svgabout" style={{ backgroundImage:" linear-gradient(rgb(41 48 79 / 59%), rgb(7 22 85 / 85%)),url(Images/d.svg)" }}> */}
            <div className="svgabout" style={{ backgroundImage: "url(Images/header.svg)" }}>
               <div className="svgabout-in">
               <h1>ABOUT ME</h1>
               </div>
            </div>
            <div className="about-in">
                <div className="fun">
                    {/*   <p id="" onClick={(event)=>{setState(1);event.target.style.backgroundColor = "white";event.target.style.color = "black"}}>ABOUT</p> */}
                    {/* <p className="focuss" onClick={()=>setState(1)}> <a href="#">ABOUT</a> </p> */}
                    
                    <p className="focuss" onClick={()=>setState(2)}>SKILLS</p>
                    <p className="focuss" onClick={()=>setState(3)}>SERVICES</p>
                    {/* catch me off shipft to about... */}
                    
                    <p className="focuss" onClick={()=>setState(4)}>AWARD </p>
                    <p className="focuss" onClick={()=>setState(5)}>Social media</p>
                    {/* <p><a target="_blank"  rel="noreferrer" href="https://www.facebook.com/profile.php?id=100071106706650"><span className="asd">< FaFacebook/></span>Facebook</a></p>

                        <p> <a target="_blank" rel="noreferrer"  href="https://www.linkedin.com/in/md-imranul-haque/" ><span className="asd">< FaLinkedin/></span>LinkedIn</a></p> */}
                </div>
                <hr className="hrr" />
                <div>
                    <div>
                        {
                            state===1?<Aboutme />:state===2?<Skillsme />:state===3?<Services />:state===4?<Awardme/>:<Socialmediame />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
